export default __webpack_public_path__ + "static/media/about.2a67178f.svg";